import { Col, Popover, Row } from "antd";
import * as React from "react";
import Link from "../../../core/ui/components/Link";
import { IRouter } from "../../../runtime/Router";

interface Props {
  router?: IRouter;
  indexHierarchyList: any[];
  style?: any;
  indexId?: number;
}

interface State {}

export default class OrganisationIndexTag extends React.Component<
  Props,
  State
> {
  renderIndexHierarchy = (indexHierarchyList, indexId, router) => {
    let indexItem = indexHierarchyList?.[0];
    if (!indexHierarchyList) {
      return null;
    }
    indexHierarchyList.pop();
    return (
      <Popover
        content={
          <div>
            {indexHierarchyList.map((item, index) => {
              let isLastElement = index === indexHierarchyList.length - 1;
              return (
                <Row key={`index-id-${item}`}>
                  <Col className={"png-index-hierarchy-item"}>
                    <div className={"png-index-hierarchy-item-content"}>
                      {item}
                    </div>
                  </Col>
                  {!isLastElement ? (
                    <Col>
                      <i className="fas fa-chevron-left png-index-hierarchy-item-icon"></i>
                    </Col>
                  ) : null}
                </Row>
              );
            })}
          </div>
        }
      >
        {router ? (
          <Link router={router} path={`/search?index=${indexId || ""}`}>
            {indexItem}
          </Link>
        ) : (
          <p>{indexItem}</p>
        )}
      </Popover>
    );
  };

  render() {
    let { indexHierarchyList, style, indexId, router } = this.props;

    return (
      <div className={"png-index-hierarchy"} style={style}>
        {this.renderIndexHierarchy(indexHierarchyList, indexId, router)}
      </div>
    );
  }
}
